export default "__VITE_ASSET__YB9LpjsI__"